import { NessUtilS } from '../../../Ness/Util/S/Function/module/NessUtilS.js';

const LABS_SPECIAL_CENTER_POS = {
  avatar_align: 'specialized-center',
};

export const makeCharactersMotionUrl = (maple_image_url, selected_motions) => {
  if (!selected_motions) return maple_image_url;
  const { emotion, action, weapon } = selected_motions;

  const emotionStr = `${emotion.id}.${emotion.frame_no.toString().padStart(2, '0')}`;

  const actionStr = `${action.id}.${action.frame_no.toString().padStart(2, '0')}`;

  return NessUtilS.makeQueryParams(maple_image_url, {
    ...(emotion && { emotion: emotionStr }),
    ...(action && { action: actionStr }),
    ...(weapon && { wmotion: weapon.id }),
    ...LABS_SPECIAL_CENTER_POS,
  });
};
